import { FtpService } from "../domainObjects/dataConnector";

export class BrowseFolderRequest {
    dataSourceType: number;
    organizationId: number;
    isUseFtp:boolean;
    ftpService: FtpService;
    supportedFileTypes?: string[];
    ingestFilePath?: string;

    constructor(dataSourceType: number, organizationId: number,isUseFtp:boolean,ftpService: FtpService, supportedFileTypes?: string[], ingestFilePath?: string) {
      this.dataSourceType = dataSourceType;
      this.organizationId = organizationId;
      this.isUseFtp = isUseFtp;
      this.ftpService = ftpService;
      this.supportedFileTypes = supportedFileTypes;
      this.ingestFilePath = ingestFilePath;
    }
}
export class BrowseFolderSelectRequest {
  organizationId: number;

  constructor(organizationId: number) {
    this.organizationId = organizationId;
  }
}

export class BrowseParquetPartitionFolderRequest {
  organizationId: number;       
  parquetPartitionFolderPath: string;

  constructor(organizationId: number, parquetPartitionFolderPath: string) {
    this.organizationId = organizationId;
    this.parquetPartitionFolderPath = parquetPartitionFolderPath;
  }
}
